import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Resolve a stored image reference (either "/api/files/..." url or a raw storage path) to a full URL.
export function fileUrl(ref) {
  if (!ref) return null;
  if (ref.startsWith("http")) return ref;
  if (ref.startsWith("/api/")) return `${BACKEND_URL}${ref}`;
  return `${API}/files/${ref}`;
}

// withCredentials sends/receives the httpOnly auth cookie set by the backend.
export const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
